import psHttp from '@patsnap/common-ps-http';
import { workspaceApiUrlPrefix } from '../../config/constants';

/**
 * 获取分配列表
 */
export function getTasksApi({
    type,
    status
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/task/tasks/${type}`,
        method: 'GET',
        params: status ? { status } : undefined,
        transformCode: true
    }).then(({ data }) => {
        return data.data || [];
    });
}

/**
 * 分配专利任务
 */
export function assignTaskApi({
    space_id,
    folder_id,
    select_mode,
    refiner,
    type,
    patent_ids,
    tz,
    assignee,
    due_date,
    priority,
    remarks,
    custom_field_ids,
    range_to,
    range_from,
    sort,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/task/assign`,
        method: 'POST',
        data: {
            space_id,
            folder_id,
            select_mode,
            refiner,
            type,
            patent_ids,
            tz,
            assignee,
            due_date,
            priority,
            remarks,
            custom_field_ids,
            start: range_from,
            end: range_to,
            sort,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 重新分配专利任务
 */
export function reassignTaskApi({
    task_id,
    assignee,
    assign_type,
    mode,
    tz,
    due_date,
    priority,
    remarks,
    custom_field_ids,
    range_to,
    range_from,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/task/${task_id}`,
        method: 'PUT',
        data: {
            task_id,
            assignee,
            assign_type,
            mode,
            tz,
            due_date,
            priority,
            remarks,
            custom_field_ids,
            start: range_from,
            end: range_to,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 获取分配专利列表
 */
export function getTaskPatentsApi({ task_id }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/task/${task_id}/patent-list`,
        method: 'GET',
        transformCode: true
    }).then(({ data }) => {
        return data.data || [];
    });
}

/**
 * 获取任务自定字段值
 */
export function getTaskCustomFieldValuesApi({
    task_id,
    patent_id,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/task/${task_id}/custom-field-values`,
        method: 'POST',
        data: {
            task_id,
            patent_id,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || [];
    });
}

/**
 * 任务专利标引
 */
export function saveTaskCustomFieldValueApi({
    task_id,
    patent_id,
    field_id,
    field_value,
    field_type
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/task/${task_id}/field`,
        method: 'POST',
        data: {
            task_id,
            patent_id,
            field_id,
            field_value,
            field_type
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 完成任务
 */
export function doneTaskReviewApi({
    task_id,
    patent_id,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/task/${task_id}/done-review`,
        method: 'POST',
        data: {
            task_id,
            patent_id,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 任务提醒
 */
export function remindTaskApi({ task_id }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/task/${task_id}/remind`,
        method: 'POST',
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 删除任务
 */
export function deleteTaskApi({ task_id }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/task/${task_id}`,
        method: 'DELETE',
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 *
 */
export function getAssignedTaskCustomField(task_id) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/task/${task_id}/field-def`,
        method: 'GET',
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}
